
import { Component, Vue, Prop, Watch, Emit, Ref, Model } from 'vue-property-decorator'
import type { ConfirmModalOptions } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { Cascader } from 'ant-design-vue'
import ConfirmModal from '../ConfirmModal/index.vue'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'

export enum CongratulateType {
  Init = 'congratulate-init',
  Recruit = 'congratulate-recruit'
}

export type CongratulateModalData = ConfirmModalOptions & {
  type?: CongratulateType
  bgPath?: string
  cityName?: string
}

@Observer
@Component({
  components: {
    Cascader,
    ConfirmModal
  }
})
export default class CongratulateModal extends Vue {
  defaultOptions: ConfirmModalOptions = {
    confirmedHide: true,
    confirmText: '去浏览',
    cancelText: '关闭'
  }

  @Ref()
  confirmModal: {
    show: (options: CongratulateModalData) => Promise<boolean>
    hide: () => void
  }

  data: {
    title: string
    subTitle: string
    description: string
    type: CongratulateType
  }

  get GuildStore() {
    return this.$store.$tonghao.Guild
  }

  get isRecruitModel() {
    return this.data?.type === CongratulateType.Recruit
  }

  get isInitModel() {
    return this.data?.type === CongratulateType.Init
  }

  async show(options: CongratulateModalData = {}) {
    const rawOpts = lodash.merge({}, this.defaultOptions, options)
    const backgroundUrl = rawOpts.bgPath ? `${this.$store.$global.static}/images/topic/pc/${rawOpts.bgPath}-pop-bg.png` : ''
    const layoutClassName = rawOpts.type ? `${rawOpts.type}-confirm-modal` : 'congratulate-confirm-modal'
    const cleanOpts: CongratulateModalData = {
      ...rawOpts,
      layoutClassName,
      backgroundUrl
    }

    const data = {
      title: `${cleanOpts.cityName}分桐`,
      subTitle: cleanOpts.type === CongratulateType.Init ? '成功开启啦~' : '助力成功',
      description:
        cleanOpts.type === CongratulateType.Init ? `恭喜${cleanOpts.cityName}桐好，今后笔墨相伴，常赴雅约` : '分桐负责人招募开启',
      type: cleanOpts.type ?? CongratulateType.Init
    }
    this.data = data

    delete cleanOpts.type
    delete cleanOpts.bgPath
    delete cleanOpts.cityName

    const res = await this.confirmModal.show(cleanOpts)

    return res === true
  }

  hide() {
    this.confirmModal.hide()
  }

  async checkShowCongratulateModal() {
    const res = await this.$store.$storeUser.messageNotice.onLoadPop()

    if (!res || !res.length) return

    for (const item of res) {
      const parsed: {
        regionName: string
        guildName: string
      } = JSON.parse(item.bizData!.jsonContent!)

      let bizId: string = ''

      if (item.noticeSubType === 50100) {
        const res = await this.show({
          type: CongratulateType.Recruit,
          bgPath: 'congratulate-recruit',
          cityName: parsed.regionName
        })

        if (res === true) {
          bizId = item.bizId
        }
      } else if (item.noticeSubType === 50101) {
        const res = await this.show({
          type: CongratulateType.Init,
          bgPath: 'congratulate-init',
          cityName: parsed.regionName
        })

        if (res === true) {
          bizId = item.bizId
        }
      }

      if (!bizId) continue

      window.open(`/topic/city/${item.bizId}`, '_blank')
      this.hide()
    }
  }

  onClosed() {}

  created(): void {
    this.checkShowCongratulateModal()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
